module.exports = __webpack_public_path__ + "static/media/red-candy.15b06a2e.png";